import type { ClientMessage, FeaturedSkill } from '@harness/shared/protocol';
import { useState } from 'react';
import type { ChatState } from '../state';
import styles from '../styles/app.module.css';
import composerStyles from '../styles/composer.module.css';
import { TEXT } from '../texts';
import { type UploadFn, useUploads } from '../uploads';
import { Banners, NoticeLine } from './Banner';
import { Composer } from './Composer';
import { Timeline } from './Timeline';

interface ChatViewProps {
  state: ChatState;
  projectId: string;
  ownName: string;
  featured?: FeaturedSkill[];
  send: (message: ClientMessage) => boolean;
  onSent: () => void;
  upload?: UploadFn;
}

function hasFiles(event: React.DragEvent): boolean {
  return [...event.dataTransfer.types].includes('Files');
}

export function ChatView({ state, projectId, ownName, featured = [], send, onSent, upload }: ChatViewProps): React.JSX.Element {
  const uploads = useUploads(projectId, upload);
  const [dragging, setDragging] = useState(false);
  return (
    <main
      className={styles.main}
      onDragOver={(event) => {
        if (!hasFiles(event)) return;
        event.preventDefault();
        setDragging(true);
      }}
      onDragLeave={(event) => {
        if (event.currentTarget === event.target) setDragging(false);
      }}
      onDrop={(event) => {
        if (!hasFiles(event)) return;
        event.preventDefault();
        setDragging(false);
        uploads.add([...event.dataTransfer.files]);
      }}
    >
      {dragging && <div className={composerStyles.drop}>{TEXT.dropHere}</div>}
      <Banners state={state} ownName={ownName} />
      <Timeline state={state} projectId={projectId} ownName={ownName} send={send} />
      <NoticeLine state={state} />
      <Composer chatId={state.chatId} running={state.running} connected={state.connected} featured={featured} uploads={uploads} send={send} onSent={onSent} />
    </main>
  );
}
